import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface TaskState {
  tasks: TaskData[];
  selectedTask: TaskData | null;
}

const initialState: TaskState = {
  tasks: [],
  selectedTask: null,
};

const taskSlice = createSlice({
  name: 'tasks',
  initialState,
  reducers: {
    setTasks(state, action: PayloadAction<TaskData[]>) {
      state.tasks = action.payload;
    },
    addTask(state, action: PayloadAction<TaskData>) {
      state.tasks.push(action.payload);
    },
    updateTask(state, action: PayloadAction<TaskData>) {
      const index = state.tasks.findIndex(task => task.task.taskId === action.payload.task.taskId);
      if (index !== -1) {
        state.tasks[index] = action.payload;
      }
    },
    deleteTask(state, action: PayloadAction<number>) {
      state.tasks = state.tasks.filter(task => task.task.taskId !== action.payload);
    },
    setSelectedTask(state, action: PayloadAction<TaskData | null>) {
      state.selectedTask = action.payload;
    },
  },
});

export const { setTasks, addTask, updateTask, deleteTask, setSelectedTask } = taskSlice.actions;

export default taskSlice.reducer;